import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  FormGroup,
  Label
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import { TextArea } from '../../components/Input';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import client from '../../utils/client';
import SweetAlerts from '../../components/SweetAlerts';
import { isSuperAdmin } from '../../utils/helpers';

const superAdmin = isSuperAdmin();

const DigitalCardsCreate = () => {
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const { handleSubmit, register } = useForm();

  const onSubmit = async (formData) => {
    setError(null);
    setSuccess(null);
    setInProgress(true);

    const { error: createError, data } = await client('admin-gc/digital-cards', { body: formData });

    if (createError) {
      setError(
        createError.message +
          (createError.invalidEmails ? `: ${createError.invalidEmails?.join(', ')}` : '')
      );
    } else {
      setSuccess(data.message);
    }
    setInProgress(false);
  };

  return (
    superAdmin && (
      <>
        <SimpleHeader name="Digital cards" />
        <Container className="mt--6" fluid>
          <Row>
            <Col>
              <div className="card-wrapper">
                <Card>
                  <CardHeader>
                    <h3 className="mb-0">Create digital cards with PLUS</h3>
                  </CardHeader>
                  <CardBody>
                    <p className="mb-0">
                      Created digital cards will be counted against stock balance.
                    </p>
                    <p className="small mt-0">
                      In super admin mode out of stock will still work but create a negative
                      balance. Make sure to fill up by ordering new cards.
                    </p>
                    {inProgress && <Spinner />}
                    {error && (
                      <Alert color="danger" className="mb-3">
                        {error}
                      </Alert>
                    )}
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Row>
                        <Col xs="12">
                          <FormGroup>
                            <Label>
                              Emails <span className="">(one per line)</span>
                            </Label>
                            <TextArea
                              name="emails"
                              className="form-control"
                              style={{ height: '200px' }}
                              register={register}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="text-align-right">
                          <Button type="submit" color="success" disabled={inProgress}>
                            {inProgress && <Spinner size="sm" />} Save
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
        {success && <SweetAlerts title="" text={success} onConfirm={() => setSuccess(null)} />}
      </>
    )
  );
};

export default DigitalCardsCreate;
